import { render, staticRenderFns } from "./PromotionalPricing.vue?vue&type=template&id=1325ec7b"
import script from "./PromotionalPricing.vue?vue&type=script&lang=js"
export * from "./PromotionalPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports